export default __webpack_public_path__ + "static/media/500a.d1715c2d.jpg";